const notice_management_en = {
  edit_message_info:'edit message information',
  empty_title:'Please enter a title',
  empty_content:'Please enter the content'
}

export default notice_management_en



// WEBPACK FOOTER //
// ./src/common/lang/notice_management/notice_management_en.js